// ⚠️⚠️⚠️⚠️ DO NOT EDIT ⚠️⚠️⚠️⚠️
// This file was automatically generated, run pnpm gen:gql to update it
/* eslint-disable */

import type * as Types from '../../../../schema/public';

import { gql } from '@apollo/client';
export type TransactionNodeFragment = { __typename?: 'BankingTransaction', id: string, rawId?: string, txType?: Types.BankingTransactionType, amount?: number, currency?: string, endingBalance?: number, status?: Types.BankingTransactionStatus, createTime?: number, description?: string, confirmations?: number, txId?: string, address?: string, provider?: string, txAction?: Types.TransactionActionTypes, providerMethod?: string };

export const TransactionNodeFragmentDoc = /*#__PURE__*/ gql`
    fragment TransactionNode on BankingTransaction {
  id
  rawId
  txType
  amount
  currency
  endingBalance
  status
  createTime
  description
  confirmations
  txId
  address
  provider
  txAction
  providerMethod
}
    `;